import React from 'react';
import { Helmet } from "react-helmet";
import AfterLogin from './AfterLogin';
import "./Affiliate.css";  

const Affiliate = () => {
    return (
        <>
            <Helmet>
                <title>Affiliate</title>
                <link rel="canonical" href="/affiliate" />
            </Helmet>
            <div>
                <AfterLogin />
            </div>
        </>
    );
};

export default Affiliate;